import Button from 'components/Button';
import { useCheckout } from 'features/events/checkout/context';
import { CheckoutSteps } from 'features/events/checkout/types';
import GoToRequestScreeningButton from './components/GoToRequestScreeningButton';
import { useTranslation } from 'react-i18next';
import {
  isMaxUsageError,
  shouldDisableCheckoutForError
} from 'features/events/checkout/helpers/checkoutErrorHelpers';

const SubmitSelectionButton = () => {
  const { tickets, checkoutSession, addonTiers, currentStep, goToStep } =
    useCheckout();
  const { t } = useTranslation(['checkout', 'common']);

  const goToSummary = () => {
    if (
      addonTiers.data.length > 0 &&
      currentStep === CheckoutSteps.TicketTiers
    ) {
      goToStep(CheckoutSteps.TicketTiersAddon);
    } else {
      goToStep(CheckoutSteps.Summary);
    }
  };

  if (tickets.tierRequiringApproval) {
    return (
      <div className="flex flex-col gap-2">
        <div className="text-sm font-normal text-neutral-500 pt-2">
          {t('checkout:approvalRequiredDescription')}
        </div>
        <GoToRequestScreeningButton goToStep={goToStep} />
      </div>
    );
  }

  if (Object.keys(tickets.selectedTicketTiers).length > 0) {
    const shouldDisableButton = shouldDisableCheckoutForError(
      checkoutSession.checkoutError
    );

    return (
      <div className="flex flex-col gap-2">
        {checkoutSession.checkoutError?.message && (
          <div
            className={`text-sm font-normal text-center pt-2 ${
              isMaxUsageError(checkoutSession.checkoutError)
                ? 'text-orange-600'
                : 'text-error'
            }`}
          >
            {checkoutSession.checkoutError.message}
          </div>
        )}
        <Button
          loading={checkoutSession.isLoadingCheckout}
          disabled={Boolean(
            shouldDisableButton || checkoutSession.isCheckoutDisabled
          )}
          variant="primaryDark"
          size="large"
          className="w-full"
          onClick={goToSummary}
        >
          {addonTiers.data.length > 0 &&
          currentStep === CheckoutSteps.TicketTiers
            ? t('common:buttons.continue')
            : t('checkout:continueToCheckout')}
        </Button>
      </div>
    );
  }

  return null;
};

export default SubmitSelectionButton;
